import { render } from "./SnapshotCreateDialog.vue?vue&type=template&id=852545fc"
import script from "./SnapshotCreateDialog.vue?vue&type=script&lang=js"
export * from "./SnapshotCreateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__